module.exports = __webpack_public_path__ + "static/media/leaf.ab31483a.svg";